import { render, staticRenderFns } from "./PowerPerformanceData.vue?vue&type=template&id=36a35c18&"
import script from "./PowerPerformanceData.vue?vue&type=script&lang=js&"
export * from "./PowerPerformanceData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports